//This accordion is a replacement for the semantic details+summary to add pretty animations to it
//and to keep track of whenever another details/summary in the same block closes.
//Aria's and tabindexes for optional interactive elements are added to keep in line with wcag needs.
export const setupAccordion = (): void => {
  const accordionArray = document.querySelectorAll<HTMLElement>("[data-accordion]")
  accordionArray.forEach((acc) => {
    acc.classList.add("accordion")
    const accordionButton = acc.querySelector<HTMLElement>("BUTTON")
    accordionButton?.addEventListener("click", onClick)
    accordionButton?.addEventListener("keypress", onClick)
    acc.setAttribute("aria-expanded", "false")

    acc.querySelectorAll<HTMLElement>("[data-accordion-interactive]").forEach((element) => {
      element.tabIndex = -1
    })
  })

  //Todo: add option for not closing when clicking anywhere outside the menu.
  if (accordionArray) {
    document.addEventListener("click", closeAllMenus)
  }
}

const onClick = (e: Event): void => {
  const target = e.target as HTMLElement
  const accordion = target.closest(".accordion") as HTMLElement | null

  if (accordion && accordion.hasAttribute("data-accordion")) {
    if (accordion.hasAttribute("open")) {
      closeMenu(accordion)
    } else {
      document.querySelectorAll<HTMLElement>("[data-accordion]").forEach((item) => {
        closeMenu(item)
      })
      openMenu(accordion)
    }
  }
}

const closeAllMenus = (e: Event): void => {
  const target = e.target as HTMLElement
  const accordion = target.closest(".accordion") as HTMLElement | null
  if (!accordion) {
    document.querySelectorAll<HTMLElement>("[data-accordion]").forEach((item) => {
      closeMenu(item)
    })
  }
}

const closeMenu = (element: HTMLElement): void => {
  element.removeAttribute("open")
  element.setAttribute("aria-expanded", "false")
  element.classList.remove("accordion-active")
  element.querySelectorAll<HTMLElement>("[data-accordion-interactive]").forEach((subElement) => {
    subElement.tabIndex = -1
  })
}

const openMenu = (element: HTMLElement): void => {
  element.setAttribute("open", "true")
  element.setAttribute("aria-expanded", "true")
  element.classList.add("accordion-active")

  element.querySelectorAll<HTMLElement>("[data-accordion-interactive]").forEach((subElement) => {
    subElement.tabIndex = 0
  })
  element.focus()
}
